import http from '@/utils/http';
export default {async create(data){const response=await http({url:'/api/admin/v1/contractProjectOrder/create',data,method:'post'});if(response?.code!==0)throw Error(response?.msg||response?.message||'项目订单创建失败');return response.data;}};
